import React from "react"

import {
	Card as CardContainer,
	Divider,
} from "@walmart-web/livingdesign-components"

import { isFeatureEnabled } from "config/feature-flags"
import SubmoduleInfo from "components/Shared/SubmoduleInfo"
import { hasAccessByPlan } from "helpers/accessPrivilegesUtils"
import useGetModuleByPath from "components/Shared/Hooks/useGetModuleByPath/useGetModuleByPath"

import "./ModuleContainer.scss"
interface ModuleContainerProps {
	submodules: Array<{
		descriptionIntlId: string
		featureFlagId: string
		iconId: React.FunctionComponent<React.SVGProps<SVGSVGElement>> | string
		titleIntlId: string
		url: string
	}>
	titleContent?: React.ReactNode
	bannerContent?: React.ReactNode
	className?: string
}

const ModuleContainer: React.FC<ModuleContainerProps> = ({
	submodules,
	titleContent,
	bannerContent,
	className: containerClassName,
}) => {
	const filteredAndEnhancedSubmodules = React.useMemo(() => {
		return submodules
			.filter(({ featureFlagId }) => isFeatureEnabled(featureFlagId))
			.map((submoduleData) => ({
				...submoduleData,
				config: useGetModuleByPath(submoduleData.url),
				enabled: hasAccessByPlan(submoduleData.featureFlagId),
			}))
	}, [submodules])

	const renderSubmodules = () =>
		filteredAndEnhancedSubmodules.map(({ url, config, ...rest }) => (
			<div key={url}>
				<SubmoduleInfo url={url} {...config} {...rest} />
				<Divider />
			</div>
		))

	return (
		<div className="module-content">
			{bannerContent}
			{titleContent && <h1 className="module-title">{titleContent}</h1>}
			<CardContainer className={containerClassName}>
				{renderSubmodules()}
			</CardContainer>
		</div>
	)
}

export default React.memo(ModuleContainer)
